export const status_options = [
  {
    label: "Created",
    value: "created",
    color: "#8678ab",
  },
  {
    label: "Change",
    value: "change",
    color: "#d07ffe",
  },
  {
    label: "Taken from a customer",
    value: "taken_from_client",
    color: "#007bff",
  },
  {
    label: "Client informed",
    value: "client_informed",
    color: "#dc3545",
  },
  {
    label: "In service",
    value: "sent_to_service",
    color: "#00aaa0",
  },
  {
    label: "Returned from service",
    value: "taken_from_service",
    color: "#ffc107",
  },
  {
    label: "Repair inhouse",
    value: "repair_inhouse",
    color: "#adcb35",
  },
  {
    label: "Closed",
    value: "closed",
    color: "#28a745",
  },
];

export const service_type_options = [
  {
    label: "Warranty",
    value: "Warranty",
  },
  {
    label: "Non-warranty",
    value: "Non-warranty",
  },
  {
    label: "Defect act",
    value: "Defect act",
  },
  {
    label: "PPG",
    value: "PPG",
  },
  {
    label: "Pre-trade",
    value: "Pre-trade",
  },
];

export const shipment_types_options = [
  { label: "DPD", value: "dpd" },
  { label: "OMNIVA", value: "omniva" },
  {
    label: "Withdrawal in the office",
    value: "at_the_store",
  },
  {
    label: "LP express",
    value: "lp_express",
  },
  {
    label: "Venipak",
    value: "venipak",
  },
  {
    label: "Matkahuolto",
    value: "matkahuolto",
  },
  {
    label: "Posti",
    value: "posti",
  },
  {
    label: "Itella",
    value: "itella",
  },
  {
    label: "ZipasGo",
    value: "zipasgo",
  },
  {
    label: "Siuntu pilotai",
    value: "siuntu_pilotai",
  },
];

//
export const warrantly_option = [
  {
    label: "0.5 year",
    value: 0.5,
  },
  {
    label: "1 year",
    value: 1,
  },
  {
    label: "2 year",
    value: 2,
  },
  {
    label: "3 year",
    value: 3,
  },
  {
    label: "4 year",
    value: 4,
  },
  {
    label: "5 year",
    value: 5,
  },
  {
    label: "There is no guarantee",
    value: 0,
  },
];

export const meanings_options = [
  {
    value: 0,
    label: "-- SELECT --",
  },
  {
    value: 1,
    label: "IMEI",
  },
  {
    value: 2,
    label: "Serial number",
  },
  {
    value: 3,
    label: "Other...",
  },
];

export const bank_options = [
  {
    value: "Swedbank",
    label: "Swedbank",
  },
  // {
  //   value: "Snoras",
  //   label: "Snoras",
  // },
  // {
  //   value: "Luminor",
  //   label: "Luminor",
  // },
  // {
  //   value: "SB",
  //   label: "SB",
  // },
];

export const autosys_apply_actions = [
  {
    label: "Auto comment",
    value: "auto_comment",
  },
  {
    label: "Auto comment NOTE",
    value: "auto_comment_note",
  },
  {
    label: "Add supplying",
    value: "add_supplying",
  },
  {
    label: "Add additional good",
    value: "add_additional_good",
  },
  {
    label: "Change courier",
    value: "change_courier",
  },
  {
    label: "Change SKU",
    value: "change_sku",
  },
];

export const available_countries = [
  {
    label: "Lithuania",
    value: "LT",
    color: "rgba(255, 206, 49, 0.12)",
  },
  {
    label: "Latvia",
    value: "LV",
    color: "rgba(200, 82, 96, 0.12)",
  },
  {
    label: "Estonia",
    value: "EE",
    color: "rgba(66, 173, 226, 0.12)",
  },
  {
    label: "England",
    value: "ENG",
    color: "rgba(206, 17, 36, 0.12)",
  },
  {
    label: "Finland",
    value: "FI",
    color: "rgb(0 150 136 / 14%)",
  },
];

export const weekOptions = [
  {
    value: "Monday",
    label: "Monday",
  },
  {
    value: "Tuesday",
    label: "Tuesday",
  },
  {
    value: "Wednesday",
    label: "Wednesday",
  },
  {
    value: "Thursday",
    label: "Thursday",
  },
  {
    value: "Friday",
    label: "Friday",
  },
  {
    value: "Saturday",
    label: "Saturday",
  },
  {
    value: "Sunday",
    label: "Sunday",
  },
];

export const tchDepartmentOptions = [
  {
    label: "Aitvaras",
    value: "tch_aitvaras",
    rivile_codes: ["U010", "U021", "U011"],
  },
  {
    label: "Plungė",
    value: "tch_plunge",
    rivile_codes: ["U21"],
  },
  {
    label: "Gargždai",
    value: "tch_gargzdai",
    rivile_codes: ["U71"],
  },
  {
    label: "Šilutė",
    value: "tch_silutė",
    rivile_codes: ["U40"],
  },
  {
    label: "Akropolis",
    value: "tch_akropolis",
    rivile_codes: ["U101", "U111"],
  },
];
